import React from "react";

const RadarEnergyChart = ({ dimensionScores }) => {


  console.log('dimensionScores---x____x->', dimensionScores)

  let getScores = (list, dimension) => {
    if (list && list.length > 0) {
      let item = list.find(ele => ele.dimension.replace("Energy", "").trim() === dimension);
      return item ? item.sumScore : 0;
    } else {
      return 0;
    }
  };

  let getCategory = (score) => {
    let obj = {
      LABEL: "",
      TEXTCOLOR: "",
      CLASSCOLOR: "",
      TEXT: ""
    }
    if (score >= 38 && score <= 50) {
      obj["LABEL"] = 'High';
      obj["TEXTCOLOR"] = 'text-[#43A047]';
      obj["COLORCLASS"] = 'bg-[#43A047]/10 text-[#43A047] border-[#43A047]/30'
      obj["TEXT"] = "Strong, sustainable capacity. An energy asset to protect and leverage."
    } else if (score >= 25 && score <= 37) {
      obj["LABEL"] = 'Moderate';
      obj["TEXTCOLOR"] = 'text-[#FFA000]';
      obj["COLORCLASS"] = 'bg-[#FFA000]/10 text-[#FFA000] border-[#FFA000]/30'
      obj["TEXT"] = "Inconsistent capacity. The behaviours exist but are unreliable - clear growth potential."
    } else if (score >= 10 && score <= 24) {
      obj["LABEL"] = 'Low';
      obj["TEXTCOLOR"] = 'text-[#E53935]';
      obj["COLORCLASS"] = 'bg-[#E53935]/10 text-[#E53935] border-[#E53935]/30'
      obj["TEXT"] = "Depleted capacity. Performance and burnout risk in this dimension; treat as the priority."
    } else {
      obj["LABEL"] = 'N/A';
      obj["TEXTCOLOR"] = 'text-gray-400'
      obj["COLORCLASS"] = 'bg-gray-50 text-gray-500 border-gray-200'
    }
    return obj
  }
  const energyConfig = [
    {
      name: "Physical",
      barColor: "bg-sky-700",
      scoreColor: "text-sky-700",
      description: 'limited capacity; a performance and burnout risk in this dimension.'
    },
    {
      name: "Emotional",
      barColor: "bg-rose-700",
      scoreColor: "text-rose-700",
      description: 'limited capacity; a performance and burnout risk in this dimension.'
    },
    {
      name: "Mental",
      barColor: "bg-teal-600",
      scoreColor: "text-teal-700",
      description: 'limited capacity; a performance and burnout risk in this dimension.'
    },
    {
      name: "Spiritual",
      barColor: "bg-purple-700",
      scoreColor: "text-purple-700",
      description: 'limited capacity; a performance and burnout risk in this dimension.'
    }
  ];

  const scoreAllList = energyConfig.map(item => {
    const score = getScores(dimensionScores, item.name);
    const category = getCategory(score) || {};

    return {
      ...item,
      score: score ?? 0,
      maxScore: 50,
      status: category?.LABEL ?? "",
      text: category?.TEXT ?? "",
      statusColor: category?.TEXTCOLOR ?? "",
      colorClass: category?.COLORCLASS ?? ""
    };
  });



  // Threshold legends mapping
  const legends = [
    { range: '10-24', text: 'Low', dotColor: 'bg-[#E53935]' },
    { range: '25- 37', text: 'Moderate', dotColor: 'bg-[#FFA000]' },
    { range: '38-50', text: 'High', dotColor: 'bg-[#43A047]' },
  ];

  // Radar Chart Data
  const center = 200;
  const maxRadius = 150;
  const maxScore = 50;

  const PhysicalScore =
    scoreAllList.find((item) => item.name === "Physical")?.score || 0;

  const EmotionalScore =
    scoreAllList.find((item) => item.name === "Emotional")?.score || 0;

  const MentalScore =
    scoreAllList.find((item) => item.name === "Mental")?.score || 0;

  const SpiritualScore =
    scoreAllList.find((item) => item.name === "Spiritual")?.score || 0;

  const getRadius = (score) => (score / maxScore) * maxRadius;

  const polygonPoints = [
    `${center},${center - getRadius(PhysicalScore)}`, // Top
    `${center + getRadius(EmotionalScore)},${center}`, // Right
    `${center},${center + getRadius(MentalScore)}`, // Bottom
    `${center - getRadius(SpiritualScore)},${center}`, // Left
  ].join(" ");

  const pointCoords = [
    {
      x: center,
      y: center - getRadius(PhysicalScore),
      color: "fill-sky-700",
    },
    {
      x: center + getRadius(EmotionalScore),
      y: center,
      color: "fill-purple-700",
    },
    {
      x: center,
      y: center + getRadius(MentalScore),
      color: "fill-teal-600",
    },
    {
      x: center - getRadius(SpiritualScore),
      y: center,
      color: "fill-rose-700",
    },
  ];

  return (
    <>
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mb-10">
        <div> */}
      <div className="relative w-full max-w-md mx-auto aspect-square flex items-center justify-center">
        {/* Top */}
        <div className="absolute top-6 left-1/2 -translate-x-1/2 text-center">
          <span className="block font-semibold text-sky-700 text-lg">
            Physical
          </span>
          <span className="block font-semibold text-sky-700 text-lg">
            ({PhysicalScore})
          </span>
        </div>

        {/* Right */}
        <div className="absolute -right-4 top-1/2 -translate-y-1/2 text-righ">
          <span className="block font-semibold text-purple-700 text-lg">
            Emotional
          </span>
          <span className="block font-semibold text-purple-700 text-lg">
            ({EmotionalScore})
          </span>
        </div>

        {/* Bottom */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center">
          <span className="block font-semibold text-teal-700 text-lg">
            Mental
          </span>
          <span className="block font-semibold text-teal-700 text-lg">
            ({MentalScore})
          </span>
        </div>

        {/* Left */}
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-left">
          <span className="block font-semibold text-rose-700 text-lg">
            Spiritual
          </span>
          <span className="block font-semibold text-rose-700 text-lg">
            ({SpiritualScore})
          </span>
        </div>

        <svg viewBox="0 0 400 400" className="w-[70%] h-[70%] overflow-visible">
          {[10, 20, 30, 40, 50].map((val) => {
            const radius = (val / maxScore) * maxRadius;
            return (
              <g key={val}>
                <polygon
                  points={`
                      ${center},${center - radius}
                      ${center + radius},${center}
                      ${center},${center + radius}
                      ${center - radius},${center}
                    `}
                  fill="none"
                  stroke="#e2e8f0"
                  strokeWidth="1"
                />

                <text
                  x={center}
                  y={center - radius + 4}
                  className="text-[14px] fill-gray-700 font-medium"
                  textAnchor="middle"
                >
                  {val}
                </text>
              </g>
            );
          })}

          {/* Center Label */}
          <text
            x={center}
            y={center + 4}
            className="text-[10px] fill-gray-700 font-medium"
            textAnchor="middle"
          >
            0
          </text>

          {/* Axis Lines */}
          <line
            x1={center}
            y1={center - maxRadius}
            x2={center}
            y2={center + maxRadius}
            stroke="#e2e8f0"
            strokeWidth="1"
          />

          <line
            x1={center - maxRadius}
            y1={center}
            x2={center + maxRadius}
            y2={center}
            stroke="#e2e8f0"
            strokeWidth="1"
          />

          {/* Radar Area */}
          <polygon
            points={polygonPoints}
            fill="rgba(20,184,166,0.08)"
            stroke="#14b8a6"
            strokeWidth="3"
          />

          {/* Data Points */}
          {pointCoords.map((point, index) => (
            <circle
              key={index}
              cx={point.x}
              cy={point.y}
              r="5"
              className={point.color}
            />
          ))}
        </svg>
      </div>

      {/* Legends */}
      <div className="border border-gray-300 rounded-xl bg-gray-50/50 px-12 py-3 grid grid-cols-2 sm:flex sm:flex-wrap items-center justify-between gap-4 mb-6">
        {legends.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-2 text-base mx-auto sm:mx-0 text-gray-900"
          >
            <span
              className={`w-2.5 h-2.5 rounded-full ${item.dotColor}`}
            />
            <span className="block font-medium">{item.range}</span>
            <span className="font-medium">{item.text}</span>
          </div>
        ))}
      </div>
      {/* </div> */}

      {/* Score Cards */}
      {/* <div className="grid grid-cols-1 gap-3">
          {scoreAllList.map((card, idx) => {
            const percentage = (card.score / card.maxScore) * 100;
            return (
              <div
                key={idx}
                className="bg-white border border-gray-300 rounded-2xl px-5 py-2 hover:shadow-md transition-all duration-300"
              >
                <div className="flex items-center justify-between mb-2">
                  <h3 className={`text-lg font-semibold ${card.scoreColor}`}>
                    {card.name}
                  </h3>
                  <div className="text-right">
                    <span className={`text-xl font-semibold ${card.scoreColor}`}>
                      {card.score}
                    </span>
                    <span className="text-gray-400 text-sm font-semibold">
                      /{card.maxScore}
                    </span>
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-3 overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-700 ${card.scoreColor.includes("sky")
                      ? "bg-sky-600"
                      : card.scoreColor.includes("rose")
                        ? "bg-rose-600"
                        : card.scoreColor.includes("teal")
                          ? "bg-teal-600"
                          : "bg-purple-600"
                      }`}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-sm text-gray-500 font-medium">
                    {percentage.toFixed(0)}% Completed
                  </span>
                  <span
                    className={`px-4 py-1 rounded-full text-sm font-semibold ${card.colorClass}`}
                  >
                    {card.status}
                  </span>
                </div>
              </div>
            );
          })}
        </div> */}
      {/* </div> */}



      <div className="border border-gray-300 rounded-xl p-4 grid grid-cols-2 md:grid-cols-4 gap-y-6 divide-x-0 sm:divide-x divide-gray-300">
        {scoreAllList.map((card, idx) => (
          <div key={idx} className="flex flex-col items-center justify-center text-center px-2 space-y-2">
            <span className={`text-lg font-semibold ${card.scoreColor}`}>
              {card.name}
            </span>
            <div className="text-lg font-semibold text-gray-800">
              <span className={card.scoreColor}>{card.score}</span>
              <span className="text-gray-400 font-semibold text-sm">
                /{card.maxScore}
              </span>
            </div>
            <span className={`text-base font-semibold px-2.5 py-1 w-32 text-center rounded border tracking-wider ${card.colorClass}`} >
              {card.status}
            </span>
          </div>
        ))}
      </div>


    </>
  );
};

export default RadarEnergyChart;